import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { useAuth } from "hooks/useAuth";
import { logout } from "slices/auth/reducer";
import { fetchUser } from "slices/auth/thunk";
import Loader from "Components/Common/Loader";
import { RootState } from "store";
import usePageTracking from "hooks/usePageTracking";
import { initAdsTracking } from "utils/adsTracking";
import { fetchMembershipThunk } from "slices/membership/thunk";
import { analyticsSetUser, analyticsSetUserProperties } from "services/analytics";
const AuthProtected = (props: any) => {
    const dispatch: any = useDispatch();
    const { isAuthenticated, loading } = useAuth();

    const [userFetched, setUserFetched] = useState(false);
    const location = useLocation();

    const userId = useSelector((state: RootState) => state.auth.user?.uuid);
    const activePlan = useSelector((state: RootState) => state.membershipState.membership.data?.active_plan);
    const selectedAgencyId = useSelector((state: RootState) => state.auth.selectedAgencyId);

    usePageTracking(userId);

    useEffect(() => {
        if (isAuthenticated) {
            dispatch(fetchUser()).then(() => dispatch(fetchMembershipThunk({ force: true }))).finally(() => setUserFetched(true));
        } else {
            dispatch(logout());
            setUserFetched(true);
        }
    }, [isAuthenticated, dispatch]);

    useEffect(() => {
        if (selectedAgencyId) {
            analyticsSetUser(selectedAgencyId);
        }
    }, [selectedAgencyId])

    useEffect(() => {
        if (activePlan) {
            analyticsSetUserProperties(
                {
                    plan: activePlan?.plan?.name,
                }
            );
        }
    }, [activePlan])

    if (!isAuthenticated && !loading) {
        return <Navigate to={{ pathname: "/login", search: location.search }} />;
    }

    if (loading || !userFetched) return <Loader />;

    return <>{props.children}</>;
};

export default AuthProtected;